/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NetworkStatusTimespan } from './networkStatusTimespan';
import { DataPlanTimespan } from './dataPlanTimespan';


export interface StatusCheckDeviceWithCloudloopPlan { 
    cloudloopPlan?: StatusCheckDeviceWithCloudloopPlan.CloudloopPlanEnum;
    comId?: string;
    dataPlanTimeline?: Array<DataPlanTimespan>;
    idDevice?: number;
    networkStatusTimeline?: Array<NetworkStatusTimespan>;
}
export namespace StatusCheckDeviceWithCloudloopPlan {
    export const CloudloopPlanEnum = {
        Unlimited: 'UNLIMITED',
        ThreeKbyte: 'THREE_KBYTE',
        SmithsonianSpecial: 'SMITHSONIAN_SPECIAL',
        PooledThreeKbyte: 'POOLED_THREE_KBYTE',
        PooledTwelveKbyte: 'POOLED_TWELVE_KBYTE',
        Test25Kbyte: 'TEST_2_5_KBYTE',
        Test4Kbyte: 'TEST_4_KBYTE'
    } as const;
    export type CloudloopPlanEnum = typeof CloudloopPlanEnum[keyof typeof CloudloopPlanEnum];
}


export type CloudloopPlanEnum = typeof StatusCheckDeviceWithCloudloopPlan.CloudloopPlanEnum[keyof typeof StatusCheckDeviceWithCloudloopPlan.CloudloopPlanEnum];
